// extracted by mini-css-extract-plugin
export default {"layout_main":"layout_layout_main__lIAyZ","layout_header":"layout_layout_header__Wco1x","layout_body":"layout_layout_body__Fb+t3","layout_footer":"layout_layout_footer__SBbYo"};